import defaultState from "./state";

const filtroBusquedaRCReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "FILTROBUSQUEDARC/LOADING": {
      return Object.assign({}, state, {
        loading: action.loading,
      });
    }

    case "FILTROBUSQUEDARC/CARGA_RECARGOS_CONVENIDOS": {
      return Object.assign({}, state, {
        recargosConvenidos: action.recargosConvenidos,
        busquedarecargos: true,
        loading: false,
      });
    }

    case "FILTROBUSQUEDARC/MODAL_FILTRO_BUSQUEDA_DETALLE": {
      return Object.assign({}, state, {
        modalFiltroBusquedaDetalle: action.modalFiltroBusquedaDetalle,
      });
    }

    case 'FILTROBUSQUEDARC/SHOW_TECNIQUES_EXCEP': {
      return Object.assign({}, state, {
        modalShowTecniques: action.modalShowTecniques,
      });
    }

    case 'FILTROBUSQUEDARC/UPDATE_DETAIL_TECNIQUES_MODAL': {
      return Object.assign({}, state, {
        detailTecniques: action.detailTecniques,
      });
    }

    case "FILTROBUSQUEDARC/GUARDAR_FILTROS_BUSQUEDA": {
      return Object.assign({}, state, {
        filtrosRecargo: action.filtros,
      });
    }

    case 'FILTROBUSQUEDARC/SET_TIPO_PRESTACION': {
      return Object.assign({}, state, {
        tipoPrestacionSelected: action.tipoPrestacion,
      });
    }

    default:
      return state;
  }
};

export default filtroBusquedaRCReducer;



// WEBPACK FOOTER //
// ./src/components/RecargosConvenios/FiltroBusqueda/reducer.js